import * as actionTypes from '../actions/actionTypes';
import axios from '../../adapter/axios';

const contactInit = () => {
	return {
		type: actionTypes.CONTACT_FORM_INIT
	}
};
const contactSuccess = (successMessage) => {
	return {
		type: actionTypes.CONTACT_FORM_SUCCESS,
		successMessage: successMessage
	}
};
const contactFail = (errorMessage) => {
	return {
		type: actionTypes.CONTACT_FORM_FAIL,
		errorMessage: errorMessage
	}
};

export const submitContactRequest = (subject, content) =>  {
	return async dispatch => {
		dispatch(contactInit());
		try {
			let emailUrl = 'https://saiteja-malladi.herokuapp.com/email/send';
			const emailRequestForm = {
				subject: subject,
				content: content
			};
			let emailResponse = await axios.post(emailUrl, emailRequestForm);
			//
			// let pushNotificationUrl = 'https://api.pushed.co/1/push';
			// let pushNotificationHeader = {
			// 	'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			// };
			// let requestForm = {
			// 	app_key: 'X80FhI1OP85KknPK30f2',
			// 	app_secret: 'qv7pL6HIaMjnSPsjFnPRw9zl2Qlv9mtZz3ssTrufedcU9K64xjwRKKNjxXHb6SZX',
			// 	target_type: 'app',
			// 	content: content
			// }
			// const pushNotificationRequestBody = Object.entries(requestForm)
			// 	.map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
			// 	.join('&');
			try {
				// let pushNotificationResponse =
				// 	await axios.post(pushNotificationUrl, pushNotificationRequestBody, {headers: pushNotificationHeader});
				// if(emailResponse.status === 200 || pushNotificationResponse.status === 200) {
				if(emailResponse.status === 200) {
					dispatch(contactSuccess("Message sent."));
				} else {
					dispatch(contactFail("Server error"));
				}
			} catch (error) {
				dispatch(contactSuccess("Message sent."));
			}
		} catch (error) {
			console.log(error);
			dispatch(contactFail("Something went wrong. Please try again."));
		}
	}
};

export const toggleSideNav = (showSideNav) =>  {
	return async dispatch => {
		dispatch({
			type: actionTypes.TOGGLE_SIDE_NAV,
			showSideNav: showSideNav
		});
	}
};

